<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div
    class="m-container m-pt-40"
  >
    <PageHeader
      icon="questionCircle"
      :title="questionScreen.label"
      border
    />
    <FormSheet>
      <FormGroup
        v-for="(item, i) in questionScreen.answers"
        :key="i"
        :label="item.question"
        large
      >
        <InputOptionsTrio
          v-if="questionScreen.responseType === 'simple'"
          v-model="item.answer"
        />

        <InputOptionsSpectrum
          v-if="questionScreen.responseType === 'number'"
          v-model="item.answer"
        />
      </FormGroup>
    </FormSheet>
  </div>
</template>

<script setup>
import PageHeader from '@/components/PageHeader.vue';
import FormSheet from '@/components/FormSheet.vue';
import FormGroup from '@/components/FormGroup.vue';
import InputOptionsTrio from '@/components/InputOptionsTrio.vue';
import InputOptionsSpectrum from '@/components/InputOptionsSpectrum.vue';

defineProps({
  questionScreen: {
    type: Object,
    required: true,
  },
});

</script>
